"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const BarChart_1 = __importDefault(require("@mui/icons-material/BarChart"));
const List_1 = __importDefault(require("@mui/icons-material/List"));
const ToggleButton_1 = __importDefault(require("@mui/material/ToggleButton"));
const ToggleButtonGroup_1 = __importDefault(require("@mui/material/ToggleButtonGroup"));
const styles_1 = require("@mui/material/styles");
const material_1 = require("@mui/material");
const state_1 = require("../state");
const utils_1 = require("../utils");
const IncomeExpenseReportToggle = () => {
    const { state, dispatch } = React.useContext(state_1.ReportsStateContext);
    const { visibleSectionIncomeVsExpense } = state;
    const { palette } = (0, styles_1.useTheme)();
    const handleSectionToggle = (_, selectedSection) => {
        dispatch({ type: 'update', payload: { visibleSectionIncomeVsExpense: selectedSection } });
    };
    return (<ToggleButtonGroup_1.default size="small" value={visibleSectionIncomeVsExpense} exclusive onChange={handleSectionToggle} sx={{
            backgroundColor: palette.background.paper,
        }}>
      {[utils_1.VISIBLE_SECTIONS.graph, utils_1.VISIBLE_SECTIONS.report].map((chartType) => (<ToggleButton_1.default key={chartType} value={chartType} disabled={visibleSectionIncomeVsExpense && visibleSectionIncomeVsExpense !== chartType} sx={{
                minWidth: 160,
                color: palette.text.primary,
                '&:hover': {
                    backgroundColor: palette.background.paper,
                },
                '&.Mui-selected': {
                    backgroundColor: palette.background.paper,
                    '&:hover': {
                        backgroundColor: palette.background.paper,
                    },
                },
                '&.Mui-disabled': {
                    backgroundColor: palette.background.elevated,
                    color: palette.text.tertiary,
                },
            }}>
          {chartType === utils_1.VISIBLE_SECTIONS.graph ? <BarChart_1.default /> : <List_1.default />}
          <material_1.Typography ml={1} textTransform="capitalize" variant="subtitle2">
            {`${visibleSectionIncomeVsExpense && visibleSectionIncomeVsExpense === chartType ? 'Show' : 'Hide'} ${chartType}`}
          </material_1.Typography>
        </ToggleButton_1.default>))}
    </ToggleButtonGroup_1.default>);
};
exports.default = IncomeExpenseReportToggle;
